import Content from "content/content";
import { FC, useRef, useState } from "react";

import InputError from "../../styles/input/InputError.styled";
import InputLabel from "../../styles/input/InputLabel.styled";
import NativeDatePicker from "./styles/NativeDatePicker.styled";
import StyledDatePicker from "./styles/StyledDatePicker.styled";

interface DatePickerProps {
  id: string;
  label: string;
  error: string | null;
  onChange: (value: string) => void;
  onFocus?: () => void;
  value: string;
  disabled?: boolean;
  min?: string;
  max?: string;
}

const DatePicker: FC<DatePickerProps> = ({
  id,
  label,
  value,
  disabled,
  error,
  onChange,
  onFocus,
  min,
  max,
}) => {
  const pickerRef = useRef<HTMLInputElement>(null);
  const [focused, setFocused] = useState(false);
  const direction = Content.shared.instance.dir();

  const onPickerClick = () => {
    pickerRef.current?.focus();
  };

  return (
    <StyledDatePicker id={id} onClick={onPickerClick} direction={direction}>
      <InputLabel>{label}</InputLabel>
      <NativeDatePicker
        direction={direction}
        aria-label={label}
        focused={focused}
        error={error}
        type="date"
        disabled={disabled}
        value={value}
        min={min}
        max={max}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => {
          setFocused(true);
          onFocus?.();
        }}
        onBlur={() => setFocused(false)}
      />
      {error ? <InputError>{error}</InputError> : null}
    </StyledDatePicker>
  );
};

export default DatePicker;
